import React from 'react';

import { Button } from 'reactstrap';

import loader from '../assets/images/loader.gif'

export const ButtonLoader = () => {
    return (
        <Button color="secondary" size="lg" disabled className="btn-loader">
        	<img alt="" src={loader} /> 
        </Button>
    )
}


// WEBPACK FOOTER //
// ./src/utils/loader.js